/* ==========================================================================
   Handys theme JS
   - Scroll reveal (IntersectionObserver)
   - Marquee auto-scroll
   - Ajax cart (add / update / remove)
   - Product variant selection
   ========================================================================== */

(function () {
  "use strict";

  var CART_ADD_URL = "/cart/add.js";
  var CART_URL = "/cart.js";
  var CART_CHANGE_URL = "/cart/change.js";

  /* ------------------------------------------------------------------ */
  /* Scroll reveal                                                       */
  /* ------------------------------------------------------------------ */

  var revealIO = null;
  var revealSafety = null;

  function initReveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll(".reveal:not(.in)");
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }

    if (!revealIO) {
      revealIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              revealIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
    }

    els.forEach(function (el) { revealIO.observe(el); });

    if (revealSafety) clearTimeout(revealSafety);
    revealSafety = setTimeout(function () {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
        el.classList.add("in");
      });
    }, 2500);
  }

  /* ------------------------------------------------------------------ */
  /* Marquee                                                              */
  /* ------------------------------------------------------------------ */

  var marqueeRafs = new WeakMap();

  function initMarquee(scope) {
    var root = scope || document;
    var tracks = root.querySelectorAll("[data-marquee-track]");
    tracks.forEach(function (m) {
      if (marqueeRafs.has(m)) return; // already running
      var x = 0;
      function step() {
        x -= 0.4;
        if (Math.abs(x) >= m.scrollWidth / 2) x = 0;
        m.style.transform = "translateX(" + x + "px)";
        var id = requestAnimationFrame(step);
        marqueeRafs.set(m, id);
      }
      var id = requestAnimationFrame(step);
      marqueeRafs.set(m, id);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart helpers                                                         */
  /* ------------------------------------------------------------------ */

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ "Content-Type": "application/json" }, opts.headers || {});
    return fetch(url, opts).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw err;
        });
      }
      return res.json();
    });
  }

  function refreshCartCount() {
    fetchJSON(CART_URL)
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
        renderDrawerCart(cart);
      })
      .catch(function () {});
  }

  function addToCart(id, quantity, formEl) {
    var body = { items: [{ id: id, quantity: quantity || 1 }] };
    return fetchJSON(CART_ADD_URL, {
      method: "POST",
      body: JSON.stringify(body)
    }).then(function (item) {
      refreshCartCount();
      openCartDrawer();
      return item;
    });
  }

  function changeCartLine(line, quantity) {
    return fetchJSON(CART_CHANGE_URL, {
      method: "POST",
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (cart) {
      renderDrawerCart(cart);
      refreshCartCount();
      if (document.querySelector("[data-cart-page]")) {
        window.location.reload();
      }
      return cart;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer rendering                                                */
  /* ------------------------------------------------------------------ */

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    return "$" + value;
  }

  function renderDrawerCart(cart) {
    var body = document.querySelector("[data-cart-drawer-body]");
    var footer = document.querySelector("[data-cart-drawer-footer]");
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty">Your bag is empty.</div>';
      if (footer) footer.style.display = "none";
      return;
    }

    if (footer) footer.style.display = "";

    var html = cart.items
      .map(function (item, index) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + (item.product_title || "") + '" loading="lazy">'
          : "";
        return (
          '<div class="cart-item" data-cart-line="' + (index + 1) + '">' +
          '<div class="cart-item__image media-fill">' + img + "</div>" +
          '<div class="cart-item__info">' +
          '<div class="cart-item__title">' + item.product_title + "</div>" +
          (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + "</div>" : "") +
          '<div class="cart-item__price">' + money(item.final_line_price) + "</div>" +
          '<div class="cart-item__controls">' +
          '<div class="product__qty">' +
          '<button type="button" data-cart-qty-decrease>&minus;</button>' +
          '<input type="text" value="' + item.quantity + '" data-cart-qty-input readonly>' +
          '<button type="button" data-cart-qty-increase>+</button>' +
          "</div>" +
          '<button type="button" class="cart-item__remove" data-cart-remove>Remove</button>' +
          "</div>" +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    body.innerHTML = html;

    if (footer) {
      var totalEl = footer.querySelector("[data-cart-subtotal]");
      if (totalEl) totalEl.textContent = money(cart.total_price);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer open/close                                              */
  /* ------------------------------------------------------------------ */

  function openCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-cart-drawer-overlay]");
    if (drawer) drawer.classList.add("is-open");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-cart-drawer-overlay]");
    if (drawer) drawer.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ------------------------------------------------------------------ */
  /* Event delegation                                                     */
  /* ------------------------------------------------------------------ */

  function onClick(e) {
    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var form = addBtn.closest("form");
      var id = addBtn.getAttribute("data-variant-id") || (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
      var qtyInput = form && form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!id) return;

      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";

      addToCart(id, qty, form)
        .then(function () {
          addBtn.textContent = "Added";
          setTimeout(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          addBtn.textContent = "Sold out";
          setTimeout(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1800);
        });
      return;
    }

    var cartToggle = e.target.closest("[data-cart-toggle]");
    if (cartToggle) {
      e.preventDefault();
      var drawer = document.querySelector("[data-cart-drawer]");
      if (drawer && drawer.classList.contains("is-open")) {
        closeCartDrawer();
      } else {
        fetchJSON(CART_URL).then(renderDrawerCart).catch(function () {});
        openCartDrawer();
      }
      return;
    }

    if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-drawer-overlay]")) {
      closeCartDrawer();
      return;
    }

    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      var lineEl = removeBtn.closest("[data-cart-line]");
      var line = lineEl ? parseInt(lineEl.getAttribute("data-cart-line"), 10) : null;
      if (line) changeCartLine(line, 0);
      return;
    }

    var decBtn = e.target.closest("[data-cart-qty-decrease]");
    var incBtn = e.target.closest("[data-cart-qty-increase]");
    if (decBtn || incBtn) {
      var wrap = (decBtn || incBtn).closest("[data-cart-line]");
      if (!wrap) return;
      var input = wrap.querySelector("[data-cart-qty-input]");
      var lineNum = parseInt(wrap.getAttribute("data-cart-line"), 10);
      var current = parseInt(input.value, 10) || 1;
      var next = decBtn ? Math.max(0, current - 1) : current + 1;
      changeCartLine(lineNum, next);
      return;
    }

    var pQtyDec = e.target.closest("[data-qty-decrease]");
    var pQtyInc = e.target.closest("[data-qty-increase]");
    if (pQtyDec || pQtyInc) {
      var qWrap = (pQtyDec || pQtyInc).closest(".product__qty");
      var qInput = qWrap && qWrap.querySelector('input[name="quantity"]');
      if (!qInput) return;
      var val = parseInt(qInput.value, 10) || 1;
      qInput.value = pQtyDec ? Math.max(1, val - 1) : val + 1;
      return;
    }

    var thumb = e.target.closest("[data-product-thumb]");
    if (thumb) {
      var mainImage = document.querySelector("[data-product-main-image]");
      var url = thumb.getAttribute("data-image-url");
      if (mainImage && url) {
        mainImage.querySelectorAll("img, .ph").forEach(function (el) { el.remove(); });
        var img = document.createElement("img");
        img.src = url;
        img.alt = thumb.querySelector("img") ? thumb.querySelector("img").alt : "";
        mainImage.appendChild(img);
      }
      thumb.parentElement.querySelectorAll("[data-product-thumb]").forEach(function (t) {
        t.classList.toggle("is-active", t === thumb);
      });
      return;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Product variant selection                                           */
  /* ------------------------------------------------------------------ */

  function initVariantPickers(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll("[data-product-form]");
    forms.forEach(function (form) {
      if (form.__handysInit) return;
      form.__handysInit = true;

      var dataEl = form.querySelector("[data-product-json]");
      if (!dataEl) return;
      var productData;
      try {
        productData = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      function getSelectedOptions() {
        var selected = [];
        form.querySelectorAll("[data-option-index]").forEach(function (input) {
          if (input.type === "radio" && !input.checked) return;
          selected[parseInt(input.getAttribute("data-option-index"), 10)] = input.value;
        });
        return selected;
      }

      function findVariant(options) {
        return productData.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === options[i]; });
        });
      }

      function updateAvailability() {
        var selected = getSelectedOptions();
        form.querySelectorAll("[data-option-index]").forEach(function (input) {
          var idx = parseInt(input.getAttribute("data-option-index"), 10);
          var testOptions = selected.slice();
          testOptions[idx] = input.value;
          var match = findVariant(testOptions);
          input.disabled = !match || !match.available;
        });
      }

      function updateUI() {
        var selected = getSelectedOptions();
        var variant = findVariant(selected);

        var addBtn = form.querySelector("[data-add-to-cart]");
        var priceEl = form.querySelector("[data-product-price]");
        var comparePriceEl = form.querySelector("[data-product-compare-price]");
        var messageEl = form.querySelector("[data-form-message]");
        var idInput = form.querySelector('[name="id"]');

        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (addBtn) addBtn.setAttribute("data-variant-id", variant.id);

          if (priceEl) priceEl.textContent = money(variant.price);
          if (comparePriceEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              comparePriceEl.textContent = money(variant.compare_at_price);
              comparePriceEl.style.display = "";
            } else {
              comparePriceEl.style.display = "none";
            }
          }

          if (variant.featured_image) {
            var mainImg = document.querySelector("[data-product-main-image]");
            if (mainImg) {
              var src = variant.featured_image.src || variant.featured_image;
              mainImg.querySelectorAll("img").forEach(function (img) { img.remove(); });
              var imgEl = document.createElement("img");
              imgEl.src = src;
              imgEl.alt = variant.featured_image.alt || productData.title;
              imgEl.loading = "eager";
              mainImg.appendChild(imgEl);
            }
          }

          if (addBtn) {
            if (variant.available) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute("data-label-add") || "Add to bag";
            } else {
              addBtn.disabled = true;
              addBtn.textContent = addBtn.getAttribute("data-label-soldout") || "Sold out";
            }
          }
          if (messageEl) messageEl.textContent = "";
        } else {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute("data-label-unavailable") || "Unavailable";
          }
          if (messageEl) messageEl.textContent = "This combination is not available.";
        }

        updateAvailability();
      }

      form.addEventListener("change", function (e) {
        if (e.target.closest("[data-option-index]")) updateUI();
      });

      updateUI();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Init / re-init on Shopify section events                            */
  /* ------------------------------------------------------------------ */

  function initAll(scope) {
    initReveal(scope);
    initMarquee(scope);
    initVariantPickers(scope);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
    refreshCartCount();
    document.addEventListener("click", onClick);
  });

  document.addEventListener("shopify:section:load", function (evt) {
    initAll(evt.target);
  });

  document.addEventListener("shopify:section:select", function (evt) {
    initAll(evt.target);
  });

  document.addEventListener("shopify:section:reorder", function () {
    initAll(document);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCartDrawer();
  });
})();
